import React, { useEffect, useState } from "react";
import { decode } from "html-entities";
import { Link, useNavigate } from "react-router-dom";
import { fetchApi, getUploadsUrl } from "../config";

import Header from '../components/Header';
import Footer from '../components/Footer';
import GlobalCta from '../components/global/GlobalCta';

import Hero from '../components/home/Hero';
import TrustedLogoTicker from '../components/home/TrustedLogoTicker';
import WhatWeDo from '../components/home/WhatWeDo';
import Spotlight from '../components/home/Spotlight';
import RecentWork from '../components/home/RecentWork';
import Testimonials from '../components/home/Testimonials';
import Toolkit from '../components/home/Toolkit';

import "./Home.css";

export default function Home() {
    const navigate = useNavigate();
    const [posts, setPosts] = useState([]);
    const [vacancies, setVacancies] = useState([]);
    const [postsLoading, setPostsLoading] = useState(true);
    const [vacanciesLoading, setVacanciesLoading] = useState(true);
    
    useEffect(() => {
        let mounted = true;

        const postsRequest = fetchApi("get_posts.php")
            .then((result) => {
                if (mounted && Array.isArray(result?.Posts)) {
                    setPosts(result.Posts.slice(0, 2));
                }
            })
            .finally(() => {
                if (mounted) setPostsLoading(false);
            });

        const vacanciesRequest = fetchApi("get_vacancies.php")
            .then((result) => {
                if (mounted && Array.isArray(result?.Vacancies)) {
                    setVacancies(result.Vacancies.slice(0, 2));
                }
            })
            .finally(() => {
                if (mounted) setVacanciesLoading(false);
            });

        Promise.allSettled([postsRequest, vacanciesRequest]);

        return () => {
            mounted = false;
        };
    }, []);

    return (
        <>
            <Header />

            <main>
                <Hero />

                <TrustedLogoTicker />

                <WhatWeDo />

                <Spotlight />

                <RecentWork />

                <Testimonials />

                <Toolkit />

                <section className="home-latest-section">
                    <div className="container">
                        <div className="home-section-heading">
                            <div>
                                <span>Insights</span>
                                <h2>Latest from our blog</h2>
                            </div>

                            <a href="/blog">View All</a>
                        </div>

                        <div className="home-latest-grid" aria-busy={postsLoading}>
                            {postsLoading &&
                                [0, 1].map((placeholder) => (
                                    <article
                                        className="home-latest-card home-latest-card-skeleton skeleton"
                                        key={`post-skeleton-${placeholder}`}
                                        aria-hidden="true"
                                    >
                                        <div className="home-latest-skeleton-image">
                                            <span className="placeholder-box" />
                                        </div>
                                        <div className="home-latest-card-content">
                                            <span className="placeholder-line small" />
                                            <span className="placeholder-line title" />
                                            <span className="placeholder-line" />
                                            <span className="placeholder-line" />
                                            <span className="placeholder-line tiny" />
                                        </div>
                                    </article>
                                ))}
                            {posts.map((post, index) => (
                                <a href={post.link || `/blog/${post.slug || post.id}`} key={post.id || post.post_id || index}>
                                    <article
                                        className="home-latest-card"
                                        key={post.id || post.post_id || index}
                                    >
                                        {(post.feature_image_url ||
                                            post.image ||
                                            post.thumbnail) && (
                                            <img loading="lazy" src={getUploadsUrl('posts', post.feature_image_url)} alt={post.feature_image_name || post.title} />
                                        )}

                                        <div className="home-latest-card-content">
                                            <span>
                                                {decode(
                                                    post.category_name || "Insights"
                                                )}
                                            </span>

                                            <h3>
                                                {decode(
                                                    post.title ||
                                                        post.post_title ||
                                                        ""
                                                )}
                                            </h3>

                                            <p>
                                                {decode(
                                                    post.short_description ||
                                                        post.short_description ||
                                                        ""
                                                )}
                                            </p>

                                            <a
                                                href={
                                                    post.link ||
                                                    `/blog/${post.slug || post.id}`
                                                }
                                            >
                                                Read More →
                                            </a>
                                        </div>
                                    </article>
                                </a>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="home-careers-section">
                    <div className="container">
                        <div className="home-section-heading">
                            <div>
                                <span>Careers</span>
                                <h2>Latest opportunities</h2>
                            </div>

                            <Link to="/career#careers">View All</Link>
                        </div>

                        <div className="job-list" aria-busy={vacanciesLoading}>
                            {vacanciesLoading &&
                                [0, 1].map((placeholder) => (
                                    <article
                                        className="job-card card home-job-skeleton skeleton"
                                        key={`vacancy-skeleton-${placeholder}`}
                                        aria-hidden="true"
                                    >
                                        <div className="job-main">
                                            <span className="placeholder-line small" />
                                            <span className="placeholder-line title" />
                                            <span className="placeholder-line" />
                                            <span className="placeholder-line home-job-skeleton-short" />
                                        </div>
                                        <span className="home-job-skeleton-button placeholder-box" />
                                    </article>
                                ))}
                            {vacancies.map((vacancy, index) => (
                                <article className="job-card card" key={vacancy.id || vacancy.job_title}>
                                    <div className="job-main">
                                        <span className="kicker">{vacancy.job_sub_title}</span>
                                        <h3>{vacancy.job_title}</h3>
                                        <p>{vacancy.job_description || vacancy.description || vacancy.excerpt || ""}</p>
                                    </div>
                                    <button
                                        className="btn btn-primary btn--sm"
                                        onClick={() => navigate(`/career?position=${encodeURIComponent(vacancy.job_title)}`)}
                                        type="button"
                                    >
                                        Apply now
                                    </button>
                                </article>
                            ))}
                        </div>
                    </div>
                </section>

            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}